<form [formGroup]="selectorForm" class="flex flex-col justify-between items-center">

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Title</mat-label>
    <input #titleInput matInput placeholder="Enter title" [(ngModel)]="data.input.title"
           particleAnalytics
           analyticsCategory="add-filter-dialog"
           analyticsAction="Filter-title"
           formControlName="expertServiceTitle"
           required>
    <mat-error
      *ngIf="selectorForm.get('expertServiceTitle').hasError('required') ||selectorForm.get('expertServiceTitle').invalid && (selectorForm.get('expertServiceTitle').dirty || selectorForm.get('expertServiceTitle').touched)">
      Please choose a service provider
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Description</mat-label>
    <textarea matInput type="text" [(ngModel)]="data.input.description"
              formControlName="expertServiceDescription"
              placeholder="Enter description" rows="5">
              </textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Service Provider</mat-label>
    <mat-select value='Select Service Provider'
                formControlName="expertServiceFirm">
      <mat-option *ngFor="let expertServiceFirm of expertServiceFirms"
                  [value]="expertServiceFirm">{{expertServiceFirm.firmName}}</mat-option>
    </mat-select>
    <mat-error
      *ngIf="selectorForm.get('expertServiceFirm').hasError('required') ||selectorForm.get('expertServiceFirm').invalid && (selectorForm.get('expertServiceFirm').dirty || selectorForm.get('expertServiceFirm').touched)">
      Please choose a service provider
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-p-100">
    <mat-label>Service</mat-label>
    <mat-select value='Select Service'
                formControlName="selectedTemplate">
      <mat-option *ngFor="let expertServiceTemplate of expertServiceTemplates"
                  [value]="expertServiceTemplate">{{expertServiceTemplate.title}}</mat-option>
    </mat-select>
    <mat-error
      *ngIf="selectorForm.get('selectedTemplate').hasError('required') || selectorForm.get('selectedTemplate').invalid && (selectorForm.get('selectedTemplate').dirty || selectorForm.get('selectedTemplate').touched)">
      Please choose a service
    </mat-error>
  </mat-form-field>
</form>
